import type { CookieOptions } from '#app'

export const REDIRECT_COOKIE_NAME = 'nuxt-redirect'

export const AUTH_COOKIE_OPTIONS = {
  secure: true,
  httpOnly: true,
  sameSite: 'lax',
  maxAge: 60 * 10, // 10 minutes
} as const satisfies CookieOptions

export const READING_DARK_MODE_COOKIE = 'juridika-reading-dark-mode'
export const READING_DARK_MODE_SAVED_COOKIE = 'juridika-reading-dark-mode-saved'
export const READING_HAS_LICENSE_COOKIE = 'juridika-reading-has-license'

export const READING_DARK_MODE_COOKIE_BASE_OPTIONS = {
  sameSite: 'lax',
  maxAge: 60 * 60 * 24 * 365,
} as const satisfies CookieOptions
